const bootstrap = require('bootstrap');

(() => {
    const inspiration_template_element = document.getElementById('template-inspiration-item');
    const inspiration_template = inspiration_template_element ? inspiration_template_element.content : null;

    const pagination_template_element = document.getElementById('pagination-template');
    const pagination_template = pagination_template_element ? pagination_template_element.content : null;

    const $form = $('#inspiration-filters');
    const $active_filters_number = $form.find('.active-filters-number');
    const $filters_collapse = $('#inspiration-filters-collapse');
    const $inspirations_list = $('.inspirations-list');
    const $inspirations_list_container = $inspirations_list.find('> .row');
    const $clear_filters_btn = $filters_collapse.find('.filters-clear-btn');

    const $pagination_numbers = $('#pagination-numbers');
    const seo_url = '/api/seo/category';

    const action_url = $form.data('action');
    const canonical_url = $form.data('canonical-url') || `${location.origin}${location.pathname}`;
    let current_url_no_pagination;

    const $sort_container = $('#inspiration-sort');
    const $sort_toggle = $sort_container.find('.dropdown-toggle');
    const $sort_dropdown = $sort_container.find('.dropdown-menu');
    const $sort_dropdown_items = $sort_dropdown.find('.dropdown-item');

    const category_partner_template_element = document.getElementById('category-partner');
    const category_partner_template = category_partner_template_element ? category_partner_template_element.content : null;

    const updateActiveFiltersNumber = () => {
        const number_selected = $form.find('.filter-item.selected').length;
        $active_filters_number.text(number_selected || '');
    };

    const getFormData = () => {
        let data = {};
        let values = [];
        $form.find('a.dropdown-item.active').each((idx, el) => {
            let category = $(el).closest('.filter-item').data('category');
            let value = $(el).data('value');
            data[category] = value;
            values.push(value);
        });
        let serialized_values = [];
        for (let key in data) {
            if (data.hasOwnProperty(key)) {
                serialized_values.push(`${key}=${data[key]}`);
            }
        }

        const sort = $sort_container.data('value');
        if (sort) {
            serialized_values.push(`__order__=${sort}`);
        }

        return {
            'serialized': serialized_values.join('&'),
            'hash': values.join('--'),
        };
    };

    const handle_seo_data = (data) => {
        if(data.meta_title)
        {
            document.title = data.meta_title;
        }
        if(data.meta_description)
        {
            $("meta[name=description]").attr('content', data.meta_description);
        }
        if(data.short_description)
        {
            $('div.lead').html(data.short_description);
        }
        if(data.long_description)
        {
            $('div.description').html(data.long_description);
        }
        if(data.header)
        {
            $('h1').text(data.header);
        }
        if (data.hideH2)
        {
            $('h2.inspiration-category').remove();

        }
        else
        {
            if(!$('h2.inspiration-category').length)
            {
                $('<h2 class="inspiration-category text-center text-md-start mb-3"></h2>').insertAfter('h1');
            }
            if(data.h2)
            {
                $('h2.inspiration-category').text(data.h2);
            }
        }


        $('header .category-partner').remove();

        if(data.partner)
        {
            let partner = $(category_partner_template).clone();
            partner.find('a').attr('href', data.partner.url);
            partner.find('img').attr('src', data.partner.image).attr('alt', data.partner.alt);
            $('header').append(partner);
        }
    };

    const updateUrl = (hash = '', sort = '') => {
        let search = sort ? `?order=${sort}` : '';
        const new_url = hash ? `${canonical_url}/${hash}${search}` : `${canonical_url}${search}`;
        if (hash.length) {
            $('.category-shortcuts').hide();
        } else {
            $('.category-shortcuts').show();
        }

        current_url_no_pagination = new_url.indexOf('?') > -1 ? `${new_url}&` : `${new_url}?`;
        window.history.pushState({}, document.title, new_url);
        $.get(`${seo_url}`, handle_seo_data);
    };


    const update_pagination = (page, page_size, total, description) => {
        const old_pagination = document.querySelector('.page-navigation');
        $pagination_numbers.text(description);

        if (old_pagination) {
            old_pagination.remove();
        }

        const total_pages = Math.ceil(total / page_size);
        if (total_pages <= 1) {
            return;
        }
        page = Math.max(1, Math.min(page, total_pages));

        const pagination = pagination_template.querySelector('.page-navigation').cloneNode(true);
        const pagination_item_template = pagination_template.querySelector('.pagination-item');

        let rel_prev = document.head.querySelector('link[rel="prev"]');
        if (!rel_prev) {
            rel_prev = document.createElement('link');
            document.head.appendChild(rel_prev);
        }
        let rel_next = document.head.querySelector('link[rel="next"]');
        if (!rel_next) {
            rel_next = document.createElement('link');
            document.head.appendChild(rel_next);
        }

        const pagination_item_prev = pagination.querySelector('.pagination-item-prev');
        if (page > 1) {
            rel_prev.href =
                pagination_item_prev.querySelector('.pagination-link').href =
                    `${current_url_no_pagination}page=${page - 1}`;
            rel_prev.rel = 'prev';
        } else {
            rel_prev.removeAttribute('rel');
            rel_prev.removeAttribute('href');
        }
        const pagination_item_next = pagination.querySelector('.pagination-item-next');
        if (page < total_pages) {
            rel_next.href =
                pagination_item_next.querySelector('.pagination-link').href =
                    `${current_url_no_pagination}page=${page + 1}`;
            rel_next.rel = 'next';
        } else {
            rel_next.removeAttribute('rel');
            rel_next.removeAttribute('href');
        }

        pagination.querySelector('.pagination-item').remove();

        let dots_placed = false;
        for (let current_page = 1; current_page <= total_pages; current_page++) {
            if (current_page > 10 && current_page < (total_pages - 1)) {
                if (!dots_placed) {
                    dots_placed = true;

                    let pagination_item = pagination_item_template.cloneNode(true);
                    let pagination_link = pagination_item.querySelector('.pagination-link');

                    pagination_link.textContent = '...';
                    pagination_item_next.insertAdjacentElement('beforebegin', pagination_item);
                }
                continue;
            }

            let pagination_item = pagination_item_template.cloneNode(true);
            let pagination_link = pagination_item.querySelector('.pagination-link');

            pagination_link.textContent = `${current_page}`;
            pagination_link.href = `${current_url_no_pagination}page=${current_page}`;

            if (current_page === page) {
                pagination_item.classList.add('active');
            } else {
                pagination_link.removeAttribute('aria-disabled');
            }

            pagination_item_next.insertAdjacentElement('beforebegin', pagination_item);
        }

        pagination_template_element.insertAdjacentElement('beforebegin', pagination);

    };

    const handleInspirationData = (data) => {
        $inspirations_list_container.children().detach();
        $sort_dropdown_items.removeClass('active');

        data.items.forEach((inspiration_data) => {
            let inspiration = $(inspiration_template).clone();
            let inspiration_link = inspiration.find('.inspiration-link');
            let href = inspiration_link.attr('href').replace('REPLACEME', inspiration_data.hasOwnProperty('slug') && inspiration_data.slug);
            let direct_url = inspiration_data.hasOwnProperty('direct_url') && inspiration_data.direct_url;

            inspiration
                .find('slot[name="name"]')
                .text(inspiration_data.name);
            inspiration
                .find('slot[name="category-name"]')
                .text(inspiration_data.category.name);
            if (direct_url) {
                inspiration
                    .find('.inspiration-link')
                    .attr('href', direct_url)
                    .attr('target', '_blank');
            } else {
                inspiration
                    .find('.inspiration-link')
                    .attr('href', href)
                    .data('href', `${href}/modal`);
            }
            inspiration
                .find('.add-inspiration')
                .attr('data-bs-inspiration-id', inspiration_data.id)
                .attr('data-inspiration-id', inspiration_data.id)
                .attr('data-bs-inspiration-image-url', inspiration_data.photo_856_miniature)
                .attr('data-inspiration-image-url', inspiration_data.photo_856_miniature)

            if (inspiration_data.hasOwnProperty('photo_url') && inspiration_data.photo_url) {
                inspiration
                    .find('.inspiration-img img')
                    .attr('src', inspiration_data.photo_856_miniature);
            }

            $inspirations_list_container.append(inspiration);
        });
        if (data.aggregations && data.aggregations['nesting-filters'] && data.aggregations['nesting-filters'].filters_values) {
            $('span.doc_count').text('(0)');
            data.aggregations['nesting-filters'].filters_values.buckets.forEach((counter) => {
                $('span.doc_count#' + counter.key).text('(' + counter.doc_count + ')');
            });
        }
        if (data.pagination) {
            update_pagination(data.pagination.page, data.pagination.page_size, data.pagination.total, data.pagination.description);
        }

        if(data.dataLayer) {
            dataLayer.push(data.dataLayer);
        }

    }

    const clearFilters = (idx, el) => {
        const $filter = $(el);
        const $active_value_name = $filter.find('.active-value-name');

        $filter.removeClass('selected');
        $filter.find('a.dropdown-item.active').removeClass('active');
        $active_value_name.text('');
    }

    const updateInspirations = () => {
        updateActiveFiltersNumber();

        const form_data = getFormData();
        const sort = $sort_container.data('value');
        updateUrl(form_data.hash, sort);

        $.get(`${action_url}?${form_data.serialized}`, handleInspirationData);
    };

    $filters_collapse.on('click', 'a.dropdown-item', (e) => {
        e.preventDefault();
        const $link = $(e.currentTarget);
        const $filter = $link.closest('.filter-item');
        const $active_value_name = $filter.find('.active-value-name');

        $filter.addClass('selected');
        $link.addClass('active');
        $active_value_name.html($link.html());

        updateInspirations();
    });

    $filters_collapse.on('click', '.filter-item.selected', (e) => {
        $(e.currentTarget).each(clearFilters);

        updateInspirations();
    });

    $sort_dropdown_items.click((e) => {
        e.preventDefault();
        let $btn = $(e.currentTarget);

        let value = $btn.data('value');

        $sort_toggle.find('.sort-label').text($btn.text());

        $sort_container.data('value', value);

        const form_data = getFormData();
        updateUrl(form_data.hash || '', value);

        $.get(`${action_url}?${form_data.serialized}`, handleInspirationData);
    });

    $clear_filters_btn.click(() => {
        $filters_collapse.find('.filter-item.selected').each(clearFilters);

        bootstrap.Collapse.getInstance($filters_collapse[0]).hide();  // TODO: Ugly!

        updateInspirations();
    });
})();
